import React from 'react';
import {VstInput, VstButton} from 'vstui';

// Renders the terms of service container
class TermsContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this._loadTOS = this._loadTOS.bind(this);
    this._acceptTOS = this._acceptTOS.bind(this);
    this._clickTOS = this._clickTOS.bind(this);
  }

  componentDidMount(){
    Fraction.Helpers.addLoader('body',"top:44px;");
    Fraction.Helpers.addLoader('header',"top:0px;height:44px;bottom:auto;background:#40404c;opacity:0.5;");
    Jigsaw.User.getInfo(function(response){
      Fraction.Helpers.removeLoader('body');
      Fraction.Helpers.removeLoader('header');
      if (response.isSuccess()){
        if (response.data.user && response.data.user.eulaAccepted){
          Fraction.User.eulaAccepted = response.data.user.eulaAccepted;
          Fraction.Helpers.redirectMe();
        }
      } else if (response.data.code===401){
        Fraction.Helpers.signin();
      }
    });

    this._loadTOS();
  }

  // try to be fancy and load a localized version of the tos from zendesk
  _loadTOS(){
    var locale = 'en-us';
    (function(container){
      $.ajax({
        url: i18n.t('locations.zendesk-tou-api'),
        jsonp: "callback",
        dataType: "jsonp",
        data: {},
        success: function(response){
          container.tos = response.article.body;
          container.tosTitle = response.article.title;
          $(".tos-textarea").html("<h2>"+container.tosTitle+"</h2>").append(container.tos).append("<hr />").append("<h2>"+container.privacyTitle+"</h2>").append(container.privacy).append("<h2>"+container.cookiesTitle+"</h2>").append(container.cookies);
        }
      });
      $.ajax({
        url: i18n.t('locations.zendesk-privacy-api'),
        jsonp: "callback",
        dataType: "jsonp",
        data: {},
        success: function(response){
          container.privacy = response.article.body;
          container.privacyTitle = response.article.title;
          $(".tos-textarea").html("<h2>"+container.tosTitle+"</h2>").append(container.tos).append("<hr />").append("<h2>"+container.privacyTitle+"</h2>").append(container.privacy).append("<h2>"+container.cookiesTitle+"</h2>").append(container.cookies);
        }
      });
      $.ajax({
        url: i18n.t('locations.zendesk-cookies-api'),
        jsonp: "callback",
        dataType: "jsonp",
        data: {},
        success: function(response){
          container.cookies = response.article.body;
          container.cookiesTitle = response.article.title;
          $(".tos-textarea").html("<h2>"+container.tosTitle+"</h2>").append(container.tos).append("<hr />").append("<h2>"+container.privacyTitle+"</h2>").append(container.privacy).append("<h2>"+container.cookiesTitle+"</h2>").append(container.cookies);
        }
      });
    })(this);
  }

  _acceptTOS(e){
    e.preventDefault();
    Fraction.Helpers.setUserInfo({eulaAccepted: true, lastBrandAccessed: Fraction.Brand.jigsawBrand}, function(response){
      if (response.isSuccess()){
        Fraction.Helpers.redirectMe();
      } else {
        if (response.data.code===401){
          Fraction.Helpers.signin();
        } else {
          Fraction.Helpers.Locations.systemError(response.data.code);
          Fraction.Helpers.removeLoader('body');
          Fraction.Helpers.removeLoader('header');
        }
      }
    });
  }

  _clickTOS(e){
    this.setState({tosAccepted: e.currentTarget.checked});
  }

  render(){
    return (
      <div onScroll={this.props.redraw}>
        { Fraction.Helpers.modalToShow }

        <div className="account">

          <div className="account-content terms">
            <h1 className="large">{i18n.t('sso.terms-and-privacy')}</h1>
            <h1 className="small">{i18n.t('sso.terms-and-privacy')}</h1>
            <div readOnly="true" className="tos-textarea">
              {i18n.t('base.loading')+"..."}
            </div>
            <form onSubmit={this._acceptTOS} id="registration-form">
              <div className="checkbox-text tos-box" id="tos-box" style={{marginTop: 0}}>
                <VstInput type="checkbox"
                          id="tos"
                          label={window.toHTML(i18n.t('registration.accept-tos', {eulaurl: i18n.t('locations.zendesk-tou'), privacyURL: i18n.t('locations.zendesk-privacy'), cookieURL: i18n.t('locations.zendesk-cookies')}))}
                          data-key="tos"
                          options="box"
                          checked={this.state.tos}
                          onChange={this._clickTOS} />
              </div>
              <VstButton id="accept-tos-button"
                         disabled={!this.state.tosAccepted}
                         options="btn-36">{i18n.t('base.accept')}</VstButton>
            </form>
          </div>
        </div>
      </div>
    );
  }

}

module.exports = TermsContainer;
